import { api } from './api';

function extractList(data) {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.results)) return data.results;
  return [];
}

function errMessage(error) {
  return (
    error.response?.data?.message ||
    error.response?.data?.error ||
    error.response?.data?.detail ||
    error.message ||
    'Request failed'
  );
}

const sportsService = {
  async listSports() {
    try {
      const response = await api.get('/sports/');
      return extractList(response.data);
    } catch (error) {
      throw new Error(errMessage(error));
    }
  },

  async listMyInterests() {
    try {
      const response = await api.get('/sports/my-interests/');
      return extractList(response.data);
    } catch (error) {
      throw new Error(errMessage(error));
    }
  },

  async addInterest(sportId) {
    try {
      const response = await api.post('/sports/my-interests/', { sport: sportId });
      return response.data;
    } catch (error) {
      throw new Error(errMessage(error));
    }
  },

  async removeInterest(sportId) {
    try {
      await api.delete(`/sports/my-interests/${sportId}/`);
    } catch (error) {
      throw new Error(errMessage(error));
    }
  },
};

export default sportsService;
